import Splide from '@splidejs/splide';

const Carousels = function () {
    const sliders = document.querySelectorAll('.main-slider');

    if (sliders.length > 0) {
        sliders.forEach(slide => new Splide(slide, {
            type: 'slide',
            autoplay: true,
        }).mount());
    }
};

export default Carousels;

